import React from 'react';
import { View, Text, StyleSheet } from '@react-18-pdf/renderer';
import moment from 'moment';

const styles = StyleSheet.create({
  footer: {
    width: '100%',
    fontWeight: 'heavy',
    marginTop: 30
  },
  row: {
    flexDirection: 'row',
    width: '100%',
    borderTop: 1,
    borderBottom: 1,
  },
  column: {
    flexDirection: 'column',
  },
  cellCabecalho: {
    padding: 6,
    fontSize: 14,
    fontWeight: 'bold',
    textAlign: 'center',
    borderBottom: 1,
  },
});

const ObraDiarioPrintPdfFooter = ({ responsavelTecnico, data }) => (
  <View style={styles.footer}>
    {/* Linha dos Títulos */}
    <View style={styles.row}>
      <View style={[styles.column, { width: '75%' }]}>
        <View style={[styles.cellCabecalho, { borderTop: 1, borderLeft: 1, borderBottom: 0, backgroundColor: '#EBEBEB' }]}>
          <Text>Responsável Técnico</Text>
        </View>
      </View>
      <View style={[styles.column, { width: '25%' }]}>
        <View style={[styles.cellCabecalho, { borderTop: 1, borderRight: 1, borderBottom: 0, borderLeft: 1, backgroundColor: '#EBEBEB' }]}>
          <Text>Data</Text>
        </View>
      </View>
    </View>

    {/* Linha dos Valores */}
    <View style={styles.row}>
      <View style={[styles.column, { width: '75%' }]}>
        <View style={[styles.cellCabecalho, { borderLeft: 1 }]}>
          <Text>{responsavelTecnico}</Text>
        </View>
      </View>
      <View style={[styles.column, { width: '25%' }]}>
        <View style={[styles.cellCabecalho, { borderLeft: 1, borderRight: 1 }]}>
          <Text>{moment(data).format('DD/MM/YYYY')}</Text>
        </View>
      </View>
    </View>
  </View>
);

export { ObraDiarioPrintPdfFooter };
